import styled from '@emotion/styled'

import { Card } from '@/components/Card'
import { HeadingL, BodyM } from '@/components/Typography'
import { CONFIG } from '@/styles/emotion.config'

export const MediaProductStepByStepBackground = styled.div`
  display: flex;
  justify-content: center;
`

export const MediaProductStepByStepContainer = styled.div`
  width: 100%;
  max-width: ${CONFIG.maxWidths.md};
  padding: 4rem 0;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  ${CONFIG.media.mobileLg} {
    flex-direction: column;
    position: relative;
    padding-top: 6.75rem;
  }

  ${CONFIG.media.mobileMd} {
    padding: 2.5rem 1rem;
    padding-top: 8.75rem;
  }
`

export const MediaProductStepByStepContent = styled.div`
  margin-left: 1.313rem;
  min-width: 18.75rem;
  min-height: 11.25rem;
  max-width: 33.75rem;

  ${CONFIG.media.mobileLg} {
    margin-left: unset;
    margin-top: -11.25rem;
    z-index: 4;
  }
`

export const MediaProductStepByStepTitle = styled(HeadingL)`
  ${CONFIG.media.mobileLg} {
    position: absolute;
    top: 2.5rem;
    left: 1rem;
  }
`

export const StepByStepContainer = styled.ol`
  margin-top: 1rem;

  ${CONFIG.media.mobileLg} {
    margin-top: unset;
  }
`

export const StepContainer = styled(Card)`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  min-height: 5rem;
  padding: 1rem 1.5rem 1rem 1rem;

  & + li {
    margin-top: 1rem;
  }
`

export const StepNumber = styled.span`
  width: 2rem;
  height: 2rem;
  min-width: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(var(--colors-primary));
  font-size: 1.5rem;
  color: #fff;
  border-radius: 50%;
  margin-right: 1rem;
`

export const StepText = styled(BodyM)`
  max-width: 28.25rem;
`
export const StepContent = styled.div`
  display: flex;
  width: 100%;
`

export const StepDownloadReferences = styled.div`
  display: flex;
  margin-top: 1.5rem;
`

export const StepDownloadReference = styled.a`
  & + a {
    margin-left: 1.375rem;
  }
`
